export default {
	form: {
		required_error: 'Questo campo è obbligatorio',
		max_length_exceeded_error:
			'Questo campo è troppo lungo (massimo {{length}} caratteri)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - Tutti i diritti riservati',
		i_consent: 'Consento',
		agreement_title: 'Accordo',
		agreement_content:
			'Utilizzando Gerositus, accetti i nostri <1>Termini e condizioni</1> e <2>Politica sulla privacy</2>.',
		agreement_terms_conditions: 'Termini e condizioni',
		agreement_privacy_policy: 'Politica sulla privacy',
	},
	navigation: {
		home: 'Home'
	},
	yes: 'Sì',
	no: 'No',
	not_defined: 'Non definito',
	please_wait: 'Attendere prego',
	search: 'Cerca',
	upgrade_required: 'Upgrade required',
	create_project_title: 'What would you like to achieve?',
	click_to_change: 'Click to change',
	click_to_create_one: 'Click <button>to create one</button>',
	no_goal: 'No goal',

	auth: {
		token_expiring_soon: 'La tua sessione scadrà tra {{minutes}} minuti',
		token_expired:
			'La tua sessione è scaduta. Sarai reindirizzato alla pagina di accesso.',
		token_check_error: 'Errore durante il controllo del token',
		session_expiring:
			'La tua sessione sta per scadere. Per favore riconnettiti. Tempo rimanente: {{time}}'
	},
	bot: {
		placeholder: 'Inserisci la tua domanda qui',
		security_notice: 'IA privata e isolata. Le tue conversazioni restano riservate.'
	},
	tutorial: {
		button: 'Tutorial',
		exit_title: 'Exit tutorial',
		exit_confirm: 'Are you sure you want to exit the tutorial?'
	},
	subscription: {
		billing_monthly: 'Monthly',
		billing_yearly: 'Yearly',
		billing_yearly_save: '(save 20%)',
		choose_now: 'Choose now'
	},
	icons: {
		used: 'Used',
		unused: 'Unused'
	},
	theme: {
		selector: 'Selettore tema',
		current_theme: 'Tema attuale',
		change_theme: 'Cambia tema'
	},
	no_description: 'Nessuna descrizione',
	situation_analysis: {
		title: 'Analisi della situazione',
		description: "Analizza automaticamente un'organizzazione, azienda o situazione",
		organization_label: 'Organizzazione / azienda',
		organization_placeholder: "Nome dell'organizzazione da analizzare",
		subject_label: 'Soggetto',
		subject_placeholder: 'Soggetto da analizzare (precompilato col nome del progetto)',
		launch_analysis: 'Avvia analisi',
		analysis_in_progress: 'Analisi in corso...',
		complete_analysis: 'Termina analisi',
		waiting_analysis: "In attesa dell'analisi...",
		waiting_summary: 'In attesa della sintesi...',
		waiting_stakes: 'In attesa delle poste in gioco...',
		waiting_risks: 'In attesa dei rischi...',
		waiting_openings: 'In attesa delle aperture...',
		waiting_stakeholders: 'In attesa degli stakeholder...',
		context_title: 'Contesto generale',
		summary_title: 'Sintesi',
		stakes_title: 'Poste in gioco',
		risks_title: 'Rischi',
		openings_title: 'Aperture',
		stakeholders_title: 'Stakeholder',
		status: 'Stato',
		likelihood: 'Probabilità',
		impact: 'Impatto',
		stakeholder: {
			importance_label: 'Importanza relativa',
			propensity_label: 'Propensione',
			engagement_label: 'Coinvolgimento',
			importance_values: {
				low: 'Bassa',
				medium: 'Media',
				high: 'Alta'
			},
			propensity_values: {
				green: 'Favorevole',
				neutral: 'Neutrale',
				orange: 'Tesa',
				red: 'Avversa'
			},
			engagement_values: {
				inactive: 'Inattivo',
				neutral: 'Neutrale',
				low: 'Basso',
				medium: 'Medio',
				high: 'Forte'
			},
			polarity_values: {
				positive: 'sostegno',
				negative: 'opposizione'
			}
		},
		risk_category_values: {
			operational: 'Operativo',
			strategic: 'Strategico',
			existential: 'Esistenziale'
		}
	},
	ai_project_generation: {
		checkbox_label: "Genera contenuto con l'IA",
		checkbox_tooltip: "Utilizza il titolo, la missione, la descrizione e gli scenari elencati sotto. La ricerca IA pubblica parte solo dopo la tua conferma («Crea progetto»).",
		title: 'Generazione di progetto assistita',
		go_to_project: 'Vai al progetto',
		create_project: 'Crea progetto',
		include_in_project_aria: 'Includi questo elemento nel progetto',
		creation_modal_title: 'Creazione degli elementi',
		creation_progress_text: '{{current}} / {{total}} elementi creati',
		error_title: 'Errore di generazione',
		complete_title: 'Generazione completata',
		complete_description: "Il progetto è stato arricchito con successo. L'IA ha identificato gli stakeholder, le poste in gioco, i rischi e le aperture chiave.",
		summary_title: "Sintesi dell'analisi",
		initializing_text: "Preparazione dell'analisi approfondita… Potrebbe richiedere dai 6 ai 10 minuti.",
		include_in_project_tooltip: 'Se selezionato, questo elemento sarà creato nel progetto al clic su «Crea progetto».',
		language_code: 'it',
		patience_with_scenarios:
			'La generazione degli scenari è complessa e può richiedere alcuni minuti. Grazie per la pazienza.',
		patience_no_scenarios:
			"L'analisi approfondita può richiedere alcuni minuti. Grazie per la pazienza.",
		phases: {
			initializing: 'Avvio',
			deep_research: 'Ricerca',
			analyzing: 'Analisi IA',
			stakeholders: 'Stakeholder',
			stakes: 'Poste in gioco',
			risks: 'Rischi',
			openings: 'Aperture',
			summary: 'Sintesi',
			fishbone: "Piano d'azione",
			entities: 'Entità',
			scenarios: 'Scenari',
			completed: 'Completato',
			error: 'Errore'
			},
		section_title: "Dettagli della generazione IA",
		disclosure_public_title: "Verso IA pubbliche",
		disclosure_public_sub: "Ricerca web. Riceve solo l'anteprima neutra qui sotto — senza intenzione, senza obiettivi.",
		disclosure_private_title: "IA privata e isolata",
		disclosure_private_sub: "Eseguita in un ambiente isolato. Nessun retraining, nessuna informazione trasmessa all'esterno. Elabora titolo, missione, descrizione e scenari.",
		zone_public: "Trasmesso a IA pubblica",
		zone_private: "Privato — non trasmesso a IA pubbliche",
		field_private_chip: "Privato e sicuro",
		field_private_tooltip: "Elaborato da un'IA privata in un ambiente isolato. Nessun retraining, nessuna informazione trasmessa all'esterno.",
		preview_title: "Anteprima della ricerca",
		preview_refresh: "Rigenera l'anteprima",
		preview_hint: "Riformulazione neutra del tuo soggetto — senza traccia d'intenzione. È esattamente ciò che verrà trasmesso alla ricerca pubblica — solo dopo la tua conferma.",
		preview_placeholder: "Inserisci almeno il titolo del progetto per generare l'anteprima.",
		launch_generation: "Avvia generazione",
		fishbone_source: 'Testo sorgente',
		scenario_n: 'Scenario {{n}}',
		scenario_optimistic: 'Favorevole',
		scenario_baseline: 'Probabile',
		scenario_pessimistic: 'Sfavorevole',
		scenario_pending: 'In attesa',
		scenario_triggers: 'Eventi scatenanti',
		scenario_action_window: "Finestra d'azione",
		scenario_detail: 'Analisi dettagliata',
		dismiss: 'Ignora i suggerimenti IA e crea il progetto',
		save_pdf: 'Salva come PDF',
		save_hint: 'Puoi salvare questa analisi prima di entrare nel progetto.',
		scenario_impacts: 'Impatti per entità',
		data: {
			scenarios: 'Scenari prospettici',
			fishbone: "Piano d'azione strategico"
		}
	},
	scenario_elaboration: {
		title: 'Elaborazione di scenario con IA',
		hypothesis: 'Ipotesi',
		initializing: "Inizializzazione dell'analisi...",
		error_title: "Errore durante l'elaborazione",
		complete_title: 'Elaborazione completata',
		complete_description: 'Lo scenario è stato elaborato con successo. Le modifiche sono state applicate.',
		analysis_preview: 'Analisi preliminare',
		applied_changes: 'Modifiche applicate',
		stakeholders_modified: 'stakeholder modificati',
		stakes_modified: 'poste in gioco modificate',
		risks_modified: 'rischi/aperture modificati',
		indicators_modified: 'indicatori modificati',
		new_elements: 'nuovi',
		steps: {
			started: 'Avvio',
			started_desc: "Inizializzazione dell'analisi...",
			fetching_project: 'Recupero del progetto',
			fetching_project_desc: 'Caricamento dei dati del progetto...',
			deep_research: 'Analisi iniziale',
			deep_research_desc: 'Analisi situazionale approfondita...',
			ai_analysis: 'Analisi IA',
			ai_analysis_desc: "L'IA sta analizzando l'impatto dell'ipotesi...",
			reformatting: 'Formattazione',
			reformatting_desc: 'Strutturazione dei risultati...',
			processing_stakeholders: 'Stakeholder',
			processing_stakeholders_desc: 'Calcolo degli impatti sugli stakeholder...',
			processing_stakes: 'Poste in gioco',
			processing_stakes_desc: 'Calcolo degli impatti sulle poste in gioco...',
			processing_risks: 'Rischi',
			processing_risks_desc: 'Calcolo degli impatti sui rischi...',
			processing_indicators: 'Indicatori',
			processing_indicators_desc: 'Calcolo degli impatti sugli indicatori...',
			completed: 'Completato',
			completed_desc: 'Analisi completata con successo',
			error: 'Errore',
			error_desc: 'Si è verificato un errore'
		}
	}
};
